<template>
    <v-dialog
      :value="confirmModalState"
      width="500px"
      light
      persistent
    >

      <v-card>
        <v-card-title class="headline subheading py-2">
            <span class="main--text">
              Mechsd de aitz wirklich abmelden?
            </span>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text class="font-weight-light main--text">
          Du kannsd fei nimma auf deine Favoriten zuagreiffa wennsd de abmeldest!
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="grey"
            flat="flat"
            @click="OnCancel"
          >
            Doch ned
          </v-btn>

          <v-btn
            color="grey"
            flat="flat"
            @click="OnLogOut"
          >
            Abmelden
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  export default {
    data () {
      return {
        dialog: false
      }
    },
    methods: {
        OnLogOut() {
          this.$store.dispatch('makeLogOut');
          if(this.$route.name === 'bookmarks') {
            this.$router.push('/');
          }
        },
        OnCancel() {
          this.$store.commit('closeConfirmModal');
        }
    },
    computed: {
      confirmModalState() {
        return this.$store.getters.confirmModal;
      }
    }
  }
</script>